import React from "react";
import "./Pricing.css";
import { Col, Container, Row } from "react-bootstrap";
import { motion } from "framer-motion";
const Pricing = () => {
  return (
    <div className="pricing-section block">
      <Container>
        <div className="title-wrap text-center mb-5">
          <motion.h6
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            className="text-uppercase text-purple mb-3 fw-bold"
          >
           <mark> PRICING & PLANS</mark>
          </motion.h6>
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.1 }}
            className="heading-premium text-white"
          >

Affordable, professional <mark>music distribution </mark>designed to get your music <mark>heard globally</mark> without compromising quality.


            {/* We offer the best recording studio rates for true world-class{" "}
            <span className="text-purple-gradient">plan</span> music production you will find anywhere
             */}
          </motion.h2>
        </div>

        <Row className="mt-5">
          {/* Single Track Plan */}
          <Col md={4} className="mb-4">
            <div className="pricing-card">
              <div className="card-header-icon">
                <div className="icon-circle">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M9 18V5l12-2v13"></path>
                    <circle cx="6" cy="18" r="3"></circle>
                    <circle cx="18" cy="16" r="3"></circle>
                  </svg>
                </div>
              </div>
              <div className="plan-name">Single Track</div>
              <div className="plan-price">
                <span className="price-main">₹299</span>
                <span className="price-crossed">₹499</span>
              </div>
              <ul className="plan-features">
  <li>
    <span className="check-icon">✓</span> 150+ Digital Stores
  </li>
  <li>
    <span className="check-icon">✓</span> Keep 80% of Your Earnings
  </li>
  <li>
    <span className="check-icon">✓</span> Release Within 24 - 48 Hours
  </li>
  <li>
    <span className="check-icon">✓</span> Real-Time Analytics
  </li>
  <li>
    <span className="check-icon">✓</span> Editorial Playlist Pitching
  </li>
  <li>
    <span className="check-icon">✓</span> FTTunes Social Media & Playlist Promotion
  </li>
  <li>
    <span className="check-icon">✓</span>YouTube Content ID
  </li>
  <li>
    <span className="check-icon">✓</span> Dolby Atmos Distribution
  </li>
  <li>
    <span className="check-icon">✓</span>Music Video Distribution (VEVO, Apple Music & More)
  </li>
  <li>
    <span className="check-icon">✓</span> Sync Licensing Opportunities
  </li>
</ul>
              <div className="card-action">
                <a
                  href="https://dashboard.fttunes.com/register.php"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn-get-started button_button__MFmXH button_color__bLscP"
                >
                  GET STARTED
                </a>
              </div>
            </div>
          </Col>

          {/* Pro Artist Plan */}
          <Col md={4} className="mb-4">
            <div className="pricing-card featured">
              <div className="popular-ribbon">MOST POPULAR</div>
              <div className="card-header-icon">
                <div className="icon-circle featured-icon">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
                  </svg>
                </div>
              </div>
              <div className="plan-name">Pro Artist</div>
              <div className="plan-price">
                <span className="price-main">₹1,499 <span style={{fontSize: '18px',marginLeft:"-10px", fontWeight: '500', color: 'rgba(255,255,255,0.7)'}}>/ year</span></span>
                <span className="price-crossed">₹2,499</span>
              </div>
              <ul className="plan-features">
  <li>
    <span className="check-icon">✓</span> Unlimited Releases
  </li>
  <li>
    <span className="check-icon">✓</span> 150+ Digital Stores
  </li>
  <li>
    <span className="check-icon">✓</span> Keep 80% of Your Earnings
  </li>
  <li>
    <span className="check-icon">✓</span> Release Within 24 - 48 Hours
  </li>
  <li>
    <span className="check-icon">✓</span> On-Demand Royalty Payouts
  </li>
  <li>
    <span className="check-icon">✓</span> Royalty Splits at Source
  </li>
  <li>
    {/* <span className="check-icon">✓</span> Monetize on Meta, TikTok & YouTube */}
  </li>
  <li>
    <span className="check-icon">✓</span> YouTube Content ID
  </li>
  <li>
    <span className="check-icon">✓</span> Music Video Distribution (VEVO, Apple Music & More)
  </li>
  <li>
    <span className="check-icon">✓</span> All-in-One Analytics Dashboard
  </li>
</ul>
              <div className="card-action">
                <a
                  href="https://dashboard.fttunes.com/register.php"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn-get-started featured-btn button_button__MFmXH button_color__bLscP"
                >
                  GET STARTED
                </a>
              </div>
            </div>
          </Col>

          {/* Record Label Plan */}
          <Col md={4} className="mb-4">
            <div className="pricing-card">
              <div className="card-header-icon">
                <div className="icon-circle">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                    <circle cx="9" cy="7" r="4"></circle>
                    <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                    <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                  </svg>
                </div>
              </div>
              <div className="plan-name">Record Label</div>
              <div className="plan-price">
                <span className="price-main">₹2,999 <span style={{fontSize: '18px',marginLeft:"-10px", fontWeight: '500', color: 'rgba(255,255,255,0.7)'}}>/ year</span></span>
                <span className="price-crossed">₹4,999</span>
              </div>
              <ul className="plan-features">
  <li>
    <span className="check-icon">✓</span> Add Unlimited Artists
  </li>
  <li>
    <span className="check-icon">✓</span> 150+ Digital Stores
  </li>
  <li>
    <span className="check-icon">✓</span> Keep 80% of Royalties
  </li>
  <li>
    <span className="check-icon">✓</span> Analytics Dashboard
  </li>
  <li>
    <span className="check-icon">✓</span> Editorial Playlist Pitching
  </li>
  <li>
    <span className="check-icon">✓</span> FTTunes Social Media & Playlist Promotion
  </li>
  <li>
    <span className="check-icon">✓</span> YouTube Official Artist Channel
  </li>
   <li>
    <span className="check-icon">✓</span> YouTube Content ID

  </li>
  <li>
    <span className="check-icon">✓</span> Music Video Distribution (VEVO, Apple Music & More)
  </li>
 
  <li>
    <span className="check-icon">✓</span> Sync Licensing Opportunities
  </li>
</ul>
              <div className="card-action">
                <a
                  href="https://dashboard.fttunes.com/register.php"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn-get-started button_button__MFmXH button_color__bLscP"
                >
                  GET STARTED
                </a>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Pricing;
